"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var modify_population_1 = require("./modify-population");
exports.modifyPopulationByScenario = modify_population_1.modifyPopulationByScenario;
exports.modifyPopulationByScenarios = modify_population_1.modifyPopulationByScenarios;
var scenario_variable_1 = require("./scenario-variable");
exports.VariableMethods = scenario_variable_1.VariableMethods;
var scenario_type_service_1 = require("./scenario-type-service");
exports.isVariableRange = scenario_type_service_1.isVariableRange;
var scenario_1 = require("./scenario");
exports.ScenarioMethods = scenario_1.ScenarioMethods;
//# sourceMappingURL=index.js.map